// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"688d7529","516":"49b5e308","583":"d81038ee","646":"f040c0fe","765":"d7a85937"}[chunkId] + ".chunk.js";
};